/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {FONTS} from "@res/fonts";
import {ICONS} from "@res/icons";
import {COLORS} from "@res/colors";

export class UserGuideButton
    extends React.Component {

    render() {
        return <a
            href={"https://sites.google.com/intuitionrobotics.com/carecenterguide/care-center"}
            target={"_blank"}
            className={`ll_h_c clickable`}
            style={{minWidth: "fit-content", textDecoration: "none", gap: 6}}
        >
            {FONTS.reg_11_secondary_dark('User Guide')}
            {ICONS.isolation_mode(COLORS.grays_4, 12)}
        </a>
    }
}